import { getClaimsUIUrl, getCustomerUISummaryUrl } from 'Foundation/Configurations/GlobalConfiguration';
import IframeResizer from 'iframe-resizer-react';
import { LoadCustomerMessage } from './Messages';
import { useEffect, useState } from 'react';
import { MyWorkCustomerTab } from './MyWork';
import CustomerLinks from './CustomerLinks';
import { Link } from '@lmig/lmds-react-link';
import { toTitleCase } from 'Utilities/StringFormatter';

export default function CustomerTab({
  message,
  activeTab,
  updateActiveTab,
  policies,
  claims,
  billing,
  name,
}: MyWorkCustomerTab) {
  const [hasLoadedCUI, setHasLoadedCUI] = useState<boolean>();
  const [customerFrame, setCustomerFrame] = useState<HTMLIFrameElement>();
  const [claimsFrame, setClaimsFrame] = useState<HTMLIFrameElement>();
  const [customerId, setCustomerId] = useState<string>();
  const [url, setUrl] = useState<string>(getCustomerUISummaryUrl());

  useEffect(() => {
        //append loginmode param to cui if present
        const queryString = window.location.search; 
        const urlParams = new URLSearchParams(queryString); 
      if (urlParams.has('loginmode') && url.toLowerCase().includes('loginmode') === false) 
          setUrl(url + `?loginmode=${urlParams.get('loginmode')}`);
  }, []);

  useEffect(() => {
    if (!customerId && message.data.customerId) setCustomerId(message.data.customerId);

    if (
      customerFrame &&
      customerFrame.contentWindow &&
      message.data.customerId !== customerId &&
      message.command == 'loadCustomer'
    )
      customerFrame.contentWindow.postMessage(JSON.stringify(message), customerFrame.src);
    else if (claimsFrame && claimsFrame.contentWindow && message.command == 'loadClaimsUI')
      claimsFrame.contentWindow.postMessage(JSON.stringify(message), claimsFrame.src);
  }, [message]);

  useEffect(() => {
    if (activeTab == 'Customer') setHasLoadedCUI(true);
    if (activeTab == 'Claims') {
      if (claimsFrame && claimsFrame.contentWindow)
        claimsFrame.contentWindow.postMessage(JSON.stringify(message), claimsFrame.src);
      window.scrollTo(0, 0);
    }
  }, [activeTab]);

  const loadInBackground = () => activeTab == 'Claims' && !hasLoadedCUI;
  const onClaimsInit = (iframe: HTMLIFrameElement) => {
    if (!claimsFrame) setClaimsFrame(iframe);
    if (iframe && iframe.contentWindow) iframe.contentWindow.postMessage(JSON.stringify(message), iframe.src);
  };

  const onCustomerInit = (iframe: HTMLIFrameElement) => {
    if (iframe && iframe.contentWindow) {
      setCustomerFrame(iframe);
      if (loadInBackground()) {
        let loadCustomerMessage: LoadCustomerMessage = {
          command: 'loadCustomer',
          data: { customerId: message.data.customerId, activeView: 'policies', customerIdType: 'MASTER' },
        };
        iframe.contentWindow.postMessage(JSON.stringify(loadCustomerMessage), iframe.src);
      } else iframe.contentWindow.postMessage(JSON.stringify(message), iframe.src);
      window.scrollTo(0, 0);
    }
  };
  const switchToCustomer = () => {
    let loadCustomerMessage: LoadCustomerMessage = {
      command: 'loadCustomer',
      data: { customerId: message.data.customerId, activeView: 'policies', customerIdType: 'MASTER' },
    };
    if (customerFrame) {
      updateActiveTab('Customer');
      customerFrame.contentWindow?.postMessage(JSON.stringify(loadCustomerMessage), customerFrame.src);
    }
  };

  return (
    <>
      {(activeTab == 'Claims' || policies || billing || claims) && (
        <div className="mywork-customer-tab-top-row">
          {activeTab == 'Claims' && (
            <Link
              variant="standalone"
              caretPosition="left"
              onClick={() => switchToCustomer()}
              className="mywork-breadcrumb"
            >
              {toTitleCase(name)}
            </Link>
          )}
          <CustomerLinks policies={policies} claims={claims} billing={billing} customerId={customerId}></CustomerLinks>
        </div>
      )}
      <IframeResizer
        onInit={onClaimsInit}
        src={getClaimsUIUrl()}
        style={{ width: '1px', minWidth: '100%' }}
        className={activeTab == 'Claims' ? '' : 'hidden'}
      />
      {url && <IframeResizer
        className={loadInBackground() || activeTab == 'Claims' ? 'hidden' : ''}
        onInit={onCustomerInit}
        src={url}
        style={{ width: '1px', minWidth: '100%' }}
      />}
    </>
  );
}
